export const environment = {
  production: true,
  apiUrl: 'https://api.patermater.org/',
  googleOAuthClientId: '977390162861-4g2ps58qrp3898peedgp5tokpf79su7f.apps.googleusercontent.com',
  host: 'https://www.askpm.app',
  httpRetryCount: 5,
  httpRetryTimeout: 5000
};
